'use client';

import { useState } from 'react';
import { Button } from '@tranquility-ai/theme-components/button';
import { Input } from '@tranquility-ai/theme-components/input';
import { useTimePilotT } from '@/i18n/useTimePilotT';
import { useMobileAssistant } from '@/shared/mobile-service/hooks/useMobileAssistant';

import '@tranquility-ai/theme-components/input.css';

/** Host-rendered assistant for the MobileForensicViewer dock slot. */
export function UfdrAssistantDock({
  acquisitionId,
  caseName,
}: {
  acquisitionId: number;
  caseName: string;
}) {
  const t = useTimePilotT();
  const assistant = useMobileAssistant({ acquisitionId, caseName });
  const [question, setQuestion] = useState('');

  return (
    <div className="flex h-full min-h-0 flex-col gap-2 p-2 text-sm text-white">
      <div className="min-h-0 flex-1 overflow-y-auto">
        {assistant.turns.map((turn) => (
          <div key={turn.epochTimeSecs} className="mb-3">
            <p className="m-0 font-medium">{turn.question}</p>
            <p className="m-0 whitespace-pre-wrap text-white/80">
              {turn.answer || (turn.pending ? t('mobileForensic.analyzing') : '')}
            </p>
          </div>
        ))}
        {assistant.error ? <p className="m-0 text-white/80">{assistant.error}</p> : null}
      </div>
      <form
        className="flex items-end gap-2"
        onSubmit={(event) => {
          event.preventDefault();
          const next = question.trim();
          if (!next || assistant.busy || !assistant.ready) return;
          assistant.ask(next);
          setQuestion('');
        }}
      >
        <Input
          value={question}
          onChange={(event) => setQuestion(event.target.value)}
          placeholder={t('mobileForensic.askPlaceholder')}
          disabled={!assistant.ready || assistant.busy}
          aria-label={t('mobileForensic.askPlaceholder')}
        />
        <Button type="submit" size="sm" disabled={!assistant.ready || assistant.busy}>
          {t('mobileForensic.ask')}
        </Button>
      </form>
    </div>
  );
}
